import type { Delivery } from '@/data/types';

// Line icons used across the app. All take their colour from the surrounding text.

const line = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export function BackIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.2} aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>;
}
export function SearchIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>;
}
export function MoreIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" /></svg>;
}
export function SendIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3.4 20.4 21 12 3.4 3.6 3.4 10l12 2-12 2z" /></svg>;
}
export function MicIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" /></svg>;
}
export function ClipIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="m20 11.5-7.8 7.8a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.5 8.5a1.7 1.7 0 0 1-2.4-2.4l7.8-7.8" /></svg>;
}
export function DocumentIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></svg>;
}
export function NoteIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M5 4h14v11l-5 5H5z" /><path d="M14 20v-5h5" /></svg>;
}
export function PlayIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4v16l13-8z" /></svg>;
}
export function PauseIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z" /></svg>;
}
export function CalendarIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2" /><path d="M3.5 10h17M8 3v4M16 3v4" /></svg>;
}
export function PersonIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5c1.2-4 4.1-6 7.5-6s6.3 2 7.5 6" /></svg>;
}
export function BubbleIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 11.5a7.5 7 0 1 1 3.6 6l-3.6 1 1.1-3.3A6.8 6.8 0 0 1 4 11.5z" /></svg>;
}
export function MailIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3" y="5.5" width="18" height="13" rx="2" /><path d="M3.5 7l8.5 6.5L20.5 7" /></svg>;
}
export function CashIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2" /><circle cx="12" cy="12" r="2.6" /><path d="M6 9.5v5M18 9.5v5" /></svg>;
}
export function TagIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8.5" r="1.5" /></svg>;
}
export function CameraIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M3 8h4l2-3h6l2 3h4v11H3z" /><circle cx="12" cy="13" r="3.5" /></svg>;
}
export function PinIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M12 21s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z" /><circle cx="12" cy="9" r="2.5" /></svg>;
}
export function HandIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 12h12M12 7l5 5-5 5" /><path d="M20 4v16" /></svg>;
}
export function CloseIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.2} aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>;
}
export function InfoIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7.5v.5" /></svg>;
}
export function ClockIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.2} aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>;
}
export function CheckIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.5} aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>;
}

export function ArchiveIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3" y="4" width="18" height="5" rx="1" /><path d="M5 9v10h14V9M10 13h4" /></svg>;
}
export function UnarchiveIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3" y="4" width="18" height="5" rx="1" /><path d="M5 9v10h14V9M12 17v-5M9.5 14.5 12 12l2.5 2.5" /></svg>;
}
export function TackIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M9 3h6l-1 6 4 3v2H6v-2l4-3zM12 14v7" /></svg>;
}
export function BellOffIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M6 8a6 6 0 0 1 9.5-4.9M18 9.5V14l2 3H8M4 17h1M3 3l18 18M10 20a2 2 0 0 0 4 0" /></svg>;
}
export function BellIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0v5l2 3H4l2-3zM10 20a2 2 0 0 0 4 0" /></svg>;
}
export function ReadIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 5h16v11H9l-5 4z" /><path d="M8.5 10.5l2.2 2.2 4.8-4.7" /></svg>;
}
export function UnreadIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 5h11M4 5v11h5v4l5-4h6v-5" /><circle cx="19" cy="6" r="3" fill="currentColor" stroke="none" /></svg>;
}
export function StarIcon({ filled = false }: { filled?: boolean }) {
  return <svg viewBox="0 0 24 24" {...line} fill={filled ? 'currentColor' : 'none'} aria-hidden="true"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z" /></svg>;
}
export function ReplyIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M9 7 4 12l5 5M4 12h10a6 6 0 0 1 6 6v1" /></svg>;
}
export function ForwardIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="m15 7 5 5-5 5M20 12H10a6 6 0 0 0-6 6v1" /></svg>;
}
export function CopyIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" /></svg>;
}
export function TrashIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></svg>;
}
export function EditIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="m13.5 6.5 4 4" /></svg>;
}
export function NewChatIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 5h16v11H9l-5 4z" /><path d="M12 8v5M9.5 10.5h5" /></svg>;
}
/** The bug icon: report something not working, or an idea (Gary, 19 Oct). */
export function BugIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="8" y="7" width="8" height="13" rx="4" /><path d="M10 7a2 2 0 0 1 4 0M12 11v9M4 13h4M16 13h4M5 8l3 2M19 8l-3 2M5 19l3-2M19 19l-3-2" /></svg>;
}
export function ArrowDownIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.4} aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>;
}

/** WhatsApp-style delivery marks: clock, one tick, two grey ticks, two blue ticks. */
export function Ticks({ delivery }: { delivery?: Delivery }) {
  if (!delivery) return null;
  if (delivery === 'failed') return <span className="chats-ticks-failed" aria-label="Not delivered">!</span>;
  if (delivery === 'pending') {
    return <svg className="chats-ticks" viewBox="0 0 18 11" fill="none" stroke="currentColor" strokeWidth="1.4" aria-label="Sending"><circle cx="7" cy="5.5" r="4" /><path d="M7 3.5v2l1.4 1" /></svg>;
  }
  if (delivery === 'sent') {
    return <svg className="chats-ticks" viewBox="0 0 18 11" {...line} strokeWidth={1.6} aria-label="Sent"><path d="M1.5 6l3.5 3.5L12.5 1.5" /></svg>;
  }
  return (
    <svg className={`chats-ticks${delivery === 'read' ? ' chats-ticks--read' : ''}`} viewBox="0 0 18 11" {...line} strokeWidth={1.6} aria-label={delivery === 'read' ? 'Read' : 'Delivered'}>
      <path d="M1 6l3.5 3.5L12 1.5M7.5 8.5l1 1L16.5 1.5" />
    </svg>
  );
}
export function HelpIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.6" /><circle cx="12" cy="17" r=".6" fill="currentColor" /></svg>;
}
export function SmileIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M8.5 14.5c.9 1.3 2.1 2 3.5 2s2.6-.7 3.5-2" /><circle cx="9" cy="10" r=".7" fill="currentColor" /><circle cx="15" cy="10" r=".7" fill="currentColor" /></svg>;
}
export function PlusIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.2} aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>;
}
export function SparkIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" /><path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" /></svg>;
}
export function LinkIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" /></svg>;
}
/** The chat list beside the chat, shown or hidden (Gary, 18 Oct). */
export function PanelLeftIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" /></svg>;
}
/** The Info panel beside the chat, shown or hidden. */
export function PanelRightIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M15 4v16" /></svg>;
}
/** The chat list's filter (Gary, 18 Oct). */
export function FilterIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4" /></svg>;
}
/** Ask Leo the same question again. */
export function RetryIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7" /><path d="M20 4v7h-7" /></svg>;
}
/** Switch to the other app, Sentinel (Gary, 18 Oct): four tiles, as an app switcher. */
export function AppsIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="4" y="4" width="7" height="7" rx="1.5" /><rect x="13" y="4" width="7" height="7" rx="1.5" /><rect x="4" y="13" width="7" height="7" rx="1.5" /><rect x="13" y="13" width="7" height="7" rx="1.5" /></svg>;
}
/** A project in Ask, as Claude's folders (Gary, 18 Oct). */
export function FolderIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>;
}
/** Stop Leo while he answers. */
export function StopIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" /></svg>;
}
/** A section that opens and closes. */
/** Ted's weekly task list: a ticked box with lines. */
export function TasksIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><rect x="3.5" y="4" width="6" height="6" rx="1.5" /><path d="m5 7 1.2 1.2L8.5 6M13 7h7.5M3.5 15.5h6M13 16h7.5" /></svg>;
}

export function ChevronIcon() {
  return <svg viewBox="0 0 24 24" {...line} aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>;
}
/** Send a question to Leo. */
export function ArrowUpIcon() {
  return <svg viewBox="0 0 24 24" {...line} strokeWidth={2.4} aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6" /></svg>;
}
